<template>
<div>
  
</div>
</template>

<script>

export default {
  name: 'app-stripe-wallet-widget-filter',
};
</script>

<style>
</style>
